if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
          button: this.querySelector('button'),
          panel: this.querySelector('.disclosure__list-wrapper'),
        };

        if (this.elements.button) {
          this.elements.button.addEventListener('click', this.openSelector.bind(this));
          this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
        }

        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

        this.querySelectorAll('a:not(.cust-language)').forEach((item) => {
          item.addEventListener('click', this.onItemClick.bind(this));
        });
      }

      hidePanel() {
        if (this.elements.button && this.elements.panel) {
          this.elements.button.setAttribute('aria-expanded', 'false');
          this.elements.panel.setAttribute('hidden', true);
        }
      }

      onContainerKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;

        if (this.elements.button && this.elements.button.getAttribute('aria-expanded') === 'false') return;
        this.hidePanel();
        event.stopPropagation();
        if (this.elements.button) this.elements.button.focus();
      }

      onItemClick(event) {
        if (window.location.hostname.indexOf('.com') < 0){
          event.preventDefault();  
        }
        const form = this.querySelector('form');
        if (this.elements.input) {
          this.elements.input.value = event.currentTarget.dataset.value;
        }
        if (form && window.location.hostname.indexOf('.com') < 0) form.submit();
      }

      openSelector() {
        if (this.elements.button && this.elements.panel) {
          this.elements.panel.toggleAttribute('hidden');
          const isExpanded = this.elements.button.getAttribute('aria-expanded') === 'false';
          this.elements.button.setAttribute('aria-expanded', isExpanded.toString());
          this.elements.button.focus();
        }
      }

      closeSelector(event) {
        if (!this.elements.panel || !this.elements.button) return;

        const isChild =
          this.elements.panel.contains(event.relatedTarget) || this.elements.button.contains(event.relatedTarget);
        if (!event.relatedTarget || !isChild) {
          this.hidePanel();
        }
      }
    }
  );
}
